import { useMutation, useQuery } from 'react-query';

import { api } from '../services/axios';
import { toast } from 'react-toastify';
import { optiMutation } from './base';

export const useGetArtigo = ({ idArtigoWp, idUsuarioWordpress }) => {
  return useQuery([{ idArtigoWp, idUsuarioWordpress }], async () => {
    const { data, status } = await api.get('/plugin/artigos/artigo', {
      params: {
        idArtigoWp,
        idUsuarioWordpress,
      },
    });
    return { data, status };
  });
};

export const useGetMedias = (idUsuarioWordpress, dataInicial, dataFinal) => {
  return useQuery(
    [{ idUsuarioWordpress, dataInicial, dataFinal }],
    async () => {
      const { data, status } = await api.get(
        `/plugin/artigos/${idUsuarioWordpress}/metricas-media`,
        {
          params: {
            dataInicial,
            dataFinal,
          },
        }
      );
      return { data, status };
    },
    {
      enabled:
        idUsuarioWordpress != 0 && idUsuarioWordpress != undefined && idUsuarioWordpress != null,
    }
  );
};

export const useGetMediasDetalhes = idArtigo => {
  return useQuery(
    [{ idArtigo }],
    async () => {
      const { data, status } = await api.get(`/plugin/artigos/${idArtigo}/metricas-detalhes`);
      return { data, status };
    },
    {
      enabled: idArtigo != 0 && idArtigo != undefined && idArtigo != null,
    }
  );
};

export const useGetMediasArtigo = (idArtigo, idUsuarioWordpress, dataInicial, dataFinal) => {
  return useQuery(
    [{ idArtigo, idUsuarioWordpress, dataInicial, dataFinal }],
    async () => {
      const { data, status } = await api.get(
        `/plugin/artigos/${idUsuarioWordpress}/metricas-media/${idArtigo}`,
        {
          params: {
            dataInicial,
            dataFinal,
          },
        }
      );
      return { data, status };
    },
    {
      enabled:
        idUsuarioWordpress != 0 &&
        idUsuarioWordpress != undefined &&
        idUsuarioWordpress != null &&
        idArtigo != 0 &&
        idArtigo != undefined &&
        idArtigo != null,
    }
  );
};

export const useGetEstrutura = () => {
  return useMutation(async artigo => {
    const { data, status } = await api.post('/plugin/artigos/estrutura', artigo);
    return { data, status };
  });
};

export const useGetSelecionados = id => {
  return useQuery(
    [id],
    async () => {
      if (id) {
        const { data, status } = await api.get(`/plugin/artigos/posts-selecionados/${id}`);
        return { data, status };
      }
    },
    {
      enabled: id !== 0 && id !== undefined && id !== null && typeof id === 'number',
    }
  );
};

export const useAdicionarArtigoMinimo = () => {
  return optiMutation('/plugin/artigos/adicionar-minimo', 'post', null);
};

export const useAdicionarArtigo = () => {
  return useMutation(
    async artigo => {
      const { data, status } = await api.post('/plugin/artigos/adicionar', artigo);
      return { data, status };
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'save_post',
        });
      },
    }
  );
};

export const useAdicionarArtigoSemRelacionamento = () => {
  return useMutation(
    async artigo => {
      const { data, status } = await api.post(
        '/plugin/artigos/adicionar-sem-relacionamento',
        artigo
      );
      return { data, status };
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'save_post_sem_relacionamento',
        });
      },
    }
  );
};

export const useGetSelecionadosDetalhes = () => {
  return useMutation(
    async id => {
      const { data, status } = await api.post(`/plugin/artigos/artigos-selecionados/${id}`);
      return { data, status };
    },
    {
      onError: err => {
        toast.error(err?.response?.data?.message, {
          toastId: 'get_artigos-selecionados',
        });
      },
    }
  );
};

export const useGetTotalArtigo = idUsuarioWordpress => {
  return useQuery(
    [idUsuarioWordpress, 'totalArtigo'],
    async () => {
      const { data, status } = await api.get(`/plugin/artigos/total/${idUsuarioWordpress}`);
      return { data, status };
    },
    {
      enabled: idUsuarioWordpress !== 0,
    }
  );
};
